<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import PainelBox from '../templates/PainelBox.svelte';
	import GradeCartoes from '../../componentes/GradeCartoes.svelte';
	import CartaoRetangulo from '../../componentes/cartoes/CartaoRetangulo.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		codificarPayloadURL,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let parseDistribuicoesFalhas = [];
	let totalFalhas = 0;

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN'))
			await carregarDistribuicoesFalhasAPI(1);
		else 
			replace("/login");

		totalFalhas = parseDistribuicoesFalhas.length;
	});

	const carregarDistribuicoesFalhasAPI = async (pagina) => {
		parseDistribuicoesFalhas = [];

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});

		const resposta = await fetch(API('projetos-nao-distribuidos'), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const { dados } = await resposta.json();

		if (dados.length == 0) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Nenhuma falha de distribuição encontrada.'
			});
			
			replace("/painel/distribuicao");
		}

		if (resposta.status == StatusHttp.OK) {
			Object.values(dados).forEach( projeto => {
				parseDistribuicoesFalhas.push({
					link: '#',
					titulo: `Projeto #${projeto.codigo}`,
					descricao: `Titulo: ${projeto.titulo}`,
					acoes: [{
						url: `#/projeto/visualizar/${projeto.codigo}`,
						texto: 'Visualizar projeto'
					}]
				});
			});

			parseDistribuicoesFalhas = [...parseDistribuicoesFalhas];
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: dados?.mensagem
			});
			
			replace("/login");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Distribuições com falhas">
		
		<div class="columns mt-6">
			<div class="column">
				<p>Uma falha consiste em quando não foi possível encontrar no cadastro um(a) avaliador(a) apropriado para o projeto ou a distribuição foi desfeita por algum usuário administrador. Necessário análise e distribuição manual.</p>
				<hr>
				<p class="is-size-5 has-text-danger">Total falhas: {totalFalhas}</p>
			</div>
		</div>

	<GradeCartoes itens={parseDistribuicoesFalhas} componente={CartaoRetangulo} flexWrap={false} parametros={{ permitirSelecaoDescricao: true }} />
</PainelBox>
